/**
 * Temoignages — preuve sociale (3 cards).
 */
import { colors, fonts } from "../../styles/tokens";
import useScrollFadeIn from "../../hooks/useScrollFadeIn";

const QUOTES = [
  {
    text: "Avant je passais 2h le lundi à chercher dans mes cahiers. Maintenant tout est là en quelques secondes.",
    author: "Pasteur Samuel K.",
    eglise: "Église Bethel · Dakar",
  },
  {
    text: "Notre réseau a des membres à Paris, Lyon, Abidjan et Douala. Pour la première fois j'ai une vue complète et en temps réel.",
    author: "Évêque Marie-Claire E.",
    eglise: "Paris",
  },
  {
    text: "Même avec 35 membres ça change tout. Je sais qui est absent depuis 2 semaines, qui fête son anniversaire cette semaine.",
    author: "Pasteur Jean-Baptiste M.",
    eglise: "Bruxelles",
  },
];

export default function Temoignages() {
  const [titleRef, titleStyle] = useScrollFadeIn();

  return (
    <section style={{
      padding: "clamp(64px, 10vw, 100px) clamp(16px, 4vw, 24px)",
      background: colors.surface, fontFamily: fonts.body,
      maxWidth: "100vw", overflowX: "hidden",
    }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <h2 ref={titleRef} style={{
          ...titleStyle,
          fontFamily: fonts.heading,
          fontSize: "clamp(32px, 4vw, 48px)",
          fontWeight: 700,
          textAlign: "center",
          color: colors.text,
          marginBottom: "56px",
          letterSpacing: "-0.01em",
        }}>
          Ce que disent <span style={{ color: colors.gold }}>les pasteurs.</span>
        </h2>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "20px",
        }}>
          {QUOTES.map((q, i) => (
            <Quote key={q.author} item={q} delay={i * 100} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Quote({ item, delay }) {
  const [ref, style] = useScrollFadeIn({ delay });
  return (
    <blockquote ref={ref} style={{
      ...style,
      margin: 0,
      padding: "28px 24px",
      background: colors.card,
      border: `1px solid ${colors.border}`,
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
    }}>
      <div style={{ color: colors.gold, fontSize: "14px", marginBottom: "12px" }}>
        ⭐⭐⭐⭐⭐
      </div>
      <p style={{
        color: colors.text,
        fontSize: "15px",
        lineHeight: 1.6,
        flex: 1,
        marginBottom: "20px",
        fontStyle: "italic",
      }}>
        « {item.text} »
      </p>
      <footer style={{ borderTop: `1px solid ${colors.border}`, paddingTop: "12px" }}>
        <div style={{ color: colors.text, fontSize: "14px", fontWeight: 600 }}>
          {item.author}
        </div>
        <div style={{ color: colors.textMuted, fontSize: "12px", marginTop: "2px" }}>
          {item.eglise}
        </div>
      </footer>
    </blockquote>
  );
}
